/** Evaluates whether two rotations are close to each other. */
export function areRotationsClose(r1, r2, tolerance) {
    let diff = Math.abs(r1 - r2);
    if (diff > 180)
        diff = 360 - diff;
    return diff <= tolerance;
}
